import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnlyDigitsDirective } from './only-digits.directive';

@NgModule({
  declarations: [OnlyDigitsDirective],
  imports: [CommonModule],
  exports: [OnlyDigitsDirective]
})
export class OnlyDigitsModule {
}
